import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=ffceba80&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffceba80')) {
      api.createRecord('ffceba80', component.options)
    } else {
      api.reload('ffceba80', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=ffceba80&", function () {
      api.rerender('ffceba80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/Home.vue"
export default component.exports